var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "result-wrapper" }, [
    _vm.applied
      ? _c("section", [
          _c("div", { staticClass: "row" }, [
            _c("div", {
              staticClass: "col-6 insurance-bg auto-bg desktop-only",
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 desktop-pl-0 col-xs-12 col-md-6" },
              [_c("ApplySuccess", { attrs: { quotation: "true" } })],
              1
            ),
          ]),
        ])
      : _c("section", [
          _c(
            "div",
            { staticClass: "banner insurance auto short mobile-only" },
            [
              _c("div", { staticClass: "container" }, [
                _c("h1", [_vm._v(_vm._s(_vm.t("insurance.auto_title")))]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", {
              staticClass: "col-6 insurance-bg auto-bg desktop-only",
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 desktop-pl-0 col-xs-12 col-md-6" },
              [
                _c("div", { staticClass: "insurance-form" }, [
                  _c("div", { staticClass: "container profile-content" }, [
                    _c("h1", { staticClass: "desktop-only" }, [
                      _vm._v(
                        "\n" + _vm._s(_vm.t("insurance.auto_title")) + "\n"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(_vm._s(_vm.t("insurance.auto_question"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        class: { loading: _vm.submitting },
                        attrs: { id: "auto-form", autocomplete: "off" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.formSubmit.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "section",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.step === 1,
                                expression: "step===1",
                              },
                            ],
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.t("insurance.auto_class"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "radio-group full",
                                  class: "column-" + _vm.types.length,
                                },
                                _vm._l(_vm.types, function (item, index) {
                                  return _c(
                                    "label",
                                    { key: index, staticClass: "btn-radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.type,
                                            expression: "type",
                                          },
                                        ],
                                        attrs: {
                                          fieldTitle: _vm.t(
                                            "insurance.auto_class",
                                            {},
                                            "zh"
                                          ),
                                          fieldValue: _vm.type,
                                          fieldname: "type",
                                          "field-single": "",
                                          name: "type",
                                          type: "radio",
                                        },
                                        domProps: {
                                          value: item.code,
                                          checked: _vm._q(_vm.type, item.code),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.type = item.code
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(item.name))]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "radio-group full",
                                  class: "column-" + _vm.authes.length,
                                },
                                _vm._l(_vm.authes, function (item, index) {
                                  return _c(
                                    "label",
                                    { key: index, staticClass: "btn-radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.auth,
                                            expression: "auth",
                                          },
                                        ],
                                        attrs: {
                                          fieldValue: _vm.auth,
                                          fieldTitle:
                                            _vm.t(
                                              "insurance.auto_parallel",
                                              {},
                                              "zh"
                                            ) +
                                            "/" +
                                            _vm.t(
                                              "insurance.auto_authorized",
                                              {},
                                              "zh"
                                            ),
                                          "field-single": "",
                                          fieldname: "authorized",
                                          name: "auth",
                                          type: "radio",
                                        },
                                        domProps: {
                                          value: item.code,
                                          checked: _vm._q(_vm.auth, item.code),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.auth = item.code
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { staticClass: "inbox-label" }, [
                                  _vm._v(_vm._s(_vm.t("insurance.auto_depot"))),
                                ]),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    id: "brand-sel",
                                    options: _vm.brandOptions,
                                    fieldValue: _vm.brand,
                                    searchable: true,
                                    fieldTitle: _vm.t(
                                      "insurance.auto_depot",
                                      {},
                                      "zh"
                                    ),
                                    fieldname: "brand",
                                    required: "",
                                    label: "name",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.brandChange()
                                    },
                                  },
                                  model: {
                                    value: _vm.brand,
                                    callback: function ($$v) {
                                      _vm.brand = $$v
                                    },
                                    expression: "brand",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { staticClass: "inbox-label" }, [
                                  _vm._v(_vm._s(_vm.t("insurance.auto_model"))),
                                ]),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    id: "model-sel",
                                    options: _vm.modelOptions,
                                    fieldValue: _vm.model,
                                    searchable: true,
                                    fieldTitle: _vm.t(
                                      "insurance.auto_model",
                                      {},
                                      "zh"
                                    ),
                                    fieldname: "model",
                                    label: "name",
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.model,
                                    callback: function ($$v) {
                                      _vm.model = $$v
                                    },
                                    expression: "model",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { staticClass: "inbox-label" }, [
                                  _vm._v(
                                    _vm._s(_vm.t("insurance.manufacture_year"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    id: "year-sel",
                                    options: _vm.yearOptions,
                                    reduce: (option) => option.code,
                                    searchable: true,
                                    fieldValue: _vm.year,
                                    fieldTitle: _vm.t(
                                      "insurance.manufacture_year",
                                      {},
                                      "zh"
                                    ),
                                    fieldname: "manufacture_year",
                                    label: "name",
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.year,
                                    callback: function ($$v) {
                                      _vm.year = $$v
                                    },
                                    expression: "year",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "section",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.step === 2,
                                expression: "step===2",
                              },
                            ],
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.t("insurance.auto_owner"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "radio-group full",
                                  class: "column-" + _vm.ownerOptions.length,
                                },
                                _vm._l(
                                  _vm.ownerOptions,
                                  function (item, index) {
                                    return _c(
                                      "label",
                                      { key: index, staticClass: "btn-radio" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.owner,
                                              expression: "owner",
                                            },
                                          ],
                                          attrs: {
                                            fieldTitle: _vm.t(
                                              "insurance.auto_owner",
                                              {},
                                              "zh"
                                            ),
                                            fieldValue: _vm.owner,
                                            name: "owner",
                                            type: "radio",
                                            "field-single": "",
                                            fieldname: "owner",
                                          },
                                          domProps: {
                                            value: item.code,
                                            checked: _vm._q(
                                              _vm.owner,
                                              item.code
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.owner = item.code
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.name) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.t("insurance.auto_info"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { staticClass: "inbox-label" }, [
                                  _vm._v(_vm._s(_vm.t("insurance.auto_price"))),
                                ]),
                                _vm._v(" "),
                                _c("MoneyInput", {
                                  attrs: {
                                    value: _vm.price,
                                    fieldTitle: _vm.t(
                                      "insurance.auto_price",
                                      {},
                                      "zh"
                                    ),
                                    fieldname: "price",
                                    fieldType: "text",
                                    required: "",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { staticClass: "inbox-label" }, [
                                _vm._v(_vm._s(_vm.t("insurance.auto_ncb"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  fieldTitle: _vm.t(
                                    "insurance.auto_ncb",
                                    {},
                                    "zh"
                                  ),
                                  type: "text",
                                  fieldname: "NCB",
                                  fieldType: "text",
                                  required: "",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.t("insurance.auto_scope"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "radio-group full",
                                  class: "column-" + _vm.scopeOptions.length,
                                },
                                _vm._l(
                                  _vm.scopeOptions,
                                  function (item, index) {
                                    return _c(
                                      "label",
                                      { key: index, staticClass: "btn-radio" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.scope,
                                              expression: "scope",
                                            },
                                          ],
                                          attrs: {
                                            fieldTitle: _vm.t(
                                              "insurance.auto_scope",
                                              {},
                                              "zh"
                                            ),
                                            fieldValue: _vm.scope,
                                            "field-single": "",
                                            fieldname: "scope",
                                            name: "scope",
                                            type: "radio",
                                          },
                                          domProps: {
                                            value: item.code,
                                            checked: _vm._q(
                                              _vm.scope,
                                              item.code
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.scope = item.code
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.name) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "section",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.step === 3,
                                expression: "step===3",
                              },
                            ],
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.t("insurance.auto_drive_count"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "radio-group full",
                                  class: "column-" + _vm.driveOptions.length,
                                },
                                _vm._l(
                                  _vm.driveOptions,
                                  function (item, index) {
                                    return _c(
                                      "label",
                                      { key: index, staticClass: "btn-radio" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.driverCount,
                                              expression: "driverCount",
                                            },
                                          ],
                                          attrs: {
                                            fieldTitle: _vm.t(
                                              "insurance.auto_drive_count",
                                              {},
                                              "zh"
                                            ),
                                            fieldValue: item.name,
                                            "field-single": "",
                                            fieldname: "driver_count",
                                            name: "drive",
                                            type: "radio",
                                          },
                                          domProps: {
                                            value: item.code,
                                            checked: _vm._q(
                                              _vm.driverCount,
                                              item.code
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.driverCount = item.code
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.name) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("DriverForm", { attrs: { id: "1", title: "" } }),
                            _vm._v(" "),
                            _c("DriverForm", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.driverCount > 1,
                                  expression: "driverCount>1",
                                },
                              ],
                              attrs: {
                                id: "2",
                                title: _vm.t("insurance.auto_driver") + "2",
                              },
                            }),
                            _vm._v(" "),
                            _c("DriverForm", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.driverCount > 2,
                                  expression: "driverCount>2",
                                },
                              ],
                              attrs: {
                                id: "3",
                                title: _vm.t("insurance.auto_driver") + "3",
                              },
                            }),
                            _vm._v(" "),
                            _c("DriverForm", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.driverCount > 3,
                                  expression: "driverCount>3",
                                },
                              ],
                              attrs: {
                                id: "4",
                                title: _vm.t("insurance.auto_driver") + "4",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.t("insurance.auto_suspension"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "radio-group full",
                                  class: "column-" + _vm.boolOptions.length,
                                },
                                _vm._l(_vm.boolOptions, function (item, index) {
                                  return _c(
                                    "label",
                                    { key: index, staticClass: "btn-radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.suspension,
                                            expression: "suspension",
                                          },
                                        ],
                                        attrs: {
                                          fieldTitle: _vm.t(
                                            "insurance.auto_suspension",
                                            {},
                                            "zh"
                                          ),
                                          fieldValue: _vm.suspension,
                                          "field-single": "",
                                          fieldname: "suspension",
                                          name: "suspension",
                                          type: "radio",
                                        },
                                        domProps: {
                                          value: item.code,
                                          checked: _vm._q(
                                            _vm.suspension,
                                            item.code
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.suspension = item.code
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.t("insurance.auto_deducted"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "radio-group full",
                                  class: "column-" + _vm.boolOptions.length,
                                },
                                _vm._l(_vm.boolOptions, function (item, index) {
                                  return _c(
                                    "label",
                                    { key: index, staticClass: "btn-radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.deducted,
                                            expression: "deducted",
                                          },
                                        ],
                                        attrs: {
                                          fieldTitle: _vm.t(
                                            "insurance.auto_deducted",
                                            {},
                                            "zh"
                                          ),
                                          fieldValue: _vm.deducted,
                                          "field-single": "",
                                          fieldname: "deducted",
                                          name: "deducted",
                                          type: "radio",
                                        },
                                        domProps: {
                                          value: item.code,
                                          checked: _vm._q(
                                            _vm.deducted,
                                            item.code
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.deducted = item.code
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { staticClass: "inbox-label" }, [
                                _vm._v(
                                  _vm._s(_vm.t("insurance.auto_applicant"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  fieldTitle: _vm.t(
                                    "insurance.auto_applicant",
                                    {},
                                    "zh"
                                  ),
                                  type: "text",
                                  fieldname: "applicant",
                                  required: "",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { staticClass: "inbox-label" }, [
                                _vm._v(_vm._s(_vm.t("insurance.email"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  fieldTitle: _vm.t(
                                    "insurance.email",
                                    {},
                                    "zh"
                                  ),
                                  type: "email",
                                  fieldname: "email_address",
                                  fieldType: "email",
                                  required: "",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { staticClass: "inbox-label" }, [
                                _vm._v(_vm._s(_vm.t("insurance.mobile"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  fieldTitle: _vm.t(
                                    "insurance.mobile",
                                    {},
                                    "zh"
                                  ),
                                  type: "tel",
                                  minlength: "8",
                                  maxlength: "8",
                                  fieldname: "mobile",
                                  fieldType: "mobile",
                                  required: "",
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "disclaimer" }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.t("insurance.disclaimer"))),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.t("insurance.disclaimer_desc")
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-secondary btn-md",
                              on: { click: _vm.submitHandle },
                            },
                            [
                              _vm._v(
                                "\n" +
                                  _vm._s(
                                    _vm.step === _vm.maxStep
                                      ? _vm.t("loan.apply")
                                      : _vm.t("common.next_page")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }